module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_okunai-de986c35511c9cc0dedb30012694c833.webp";